import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
// Fixed the missing FiShield import here
const { FiCpu, FiGlobe, FiTool, FiZap, FiTarget, FiBox, FiShield } = FiIcons;

const features = [
  {
    title: "Zero-Identity Protocol",
    desc: "We don't buy aged accounts. We build fresh nodes from 0 with clean browser fingerprints and dedicated residential IPs.",
    icon: FiShield
  },
  {
    title: "Algorithmic Saturation",
    desc: "Deploy 20, 50, or 100 account nodes per network to dominate the feed through sheer volume and variation.",
    icon: FiTarget
  },
  {
    title: "AI Media Forging",
    desc: "Proprietary AI engine creating high-converting commercials and AI influencers tailored to your niche.",
    icon: FiCpu
  },
  {
    title: "Invisible Scaling",
    desc: "Our infrastructure mimics human behavior perfectly, making mass distribution look like organic growth.",
    icon: FiZap
  },
  {
    title: "Single Network Focus",
    desc: "Pricing is optimized for deep saturation of one network (TikTok, IG, or FB) for maximum ROI.",
    icon: FiGlobe
  },
  {
    title: "Industrial Assets",
    desc: "From animated videos to full-scale commercials, we forge the media that drives modern attention.",
    icon: FiBox
  }
];

export default function Features() {
  return (
    <section id="solutions" className="py-32 bg-[#050505] px-6 relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-end justify-between mb-24 gap-8">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-[#DFFF00]" />
              <span className="text-[#DFFF00] text-[10px] font-black uppercase tracking-[0.4em]">Operational Capabilities</span>
            </div>
            <h2 className="text-5xl md:text-7xl font-black uppercase tracking-tighter text-white italic leading-none">
              Infrastructure <br />
              <span className="text-[#DFFF00]">Overview.</span>
            </h2>
          </div>
          <p className="text-slate-500 text-sm font-black uppercase tracking-[0.3em] max-w-xs text-right italic">
            Engineered for high-volume attention capture.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {features.map((feature, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="bg-[#050505] p-12 hover:bg-white/[0.02] transition-colors group"
            >
              <div className="w-12 h-12 bg-[#DFFF00]/5 flex items-center justify-center mb-8 group-hover:bg-[#DFFF00] transition-all duration-500">
                <SafeIcon icon={feature.icon} className="text-[#DFFF00] text-2xl group-hover:text-black transition-colors" />
              </div>
              <h3 className="text-xl font-black uppercase tracking-tight text-white mb-4 italic">{feature.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed font-medium">
                {feature.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}